/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Report_ReasonInputs */

const en_report_reason = /** @type {(inputs: Report_ReasonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reason for report`)
};

const id_report_reason = /** @type {(inputs: Report_ReasonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alasan pelaporan`)
};

/** @type {(inputs: Report_ReasonInputs) => LocalizedString} */
const es_report_reason = en_report_reason;

/** @type {(inputs: Report_ReasonInputs) => LocalizedString} */
const fr_report_reason = en_report_reason;

/** @type {(inputs: Report_ReasonInputs) => LocalizedString} */
const de_report_reason = en_report_reason;

/** @type {(inputs: Report_ReasonInputs) => LocalizedString} */
const ja_report_reason = en_report_reason;

/** @type {(inputs: Report_ReasonInputs) => LocalizedString} */
const zh_report_reason = en_report_reason;

/** @type {(inputs: Report_ReasonInputs) => LocalizedString} */
const ar_report_reason = en_report_reason;

/** @type {(inputs: Report_ReasonInputs) => LocalizedString} */
const it_report_reason = en_report_reason;

/** @type {(inputs: Report_ReasonInputs) => LocalizedString} */
const ru_report_reason = en_report_reason;

/** @type {(inputs: Report_ReasonInputs) => LocalizedString} */
const pt_report_reason = en_report_reason;

/** @type {(inputs: Report_ReasonInputs) => LocalizedString} */
const ko_report_reason = en_report_reason;

/**
* | output |
* | --- |
* | "Reason for report" |
*
* @param {Report_ReasonInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const report_reason = /** @type {((inputs?: Report_ReasonInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Report_ReasonInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_report_reason(inputs)
	if (locale === "es") return es_report_reason(inputs)
	if (locale === "fr") return fr_report_reason(inputs)
	if (locale === "de") return de_report_reason(inputs)
	if (locale === "ja") return ja_report_reason(inputs)
	if (locale === "zh") return zh_report_reason(inputs)
	if (locale === "ar") return ar_report_reason(inputs)
	if (locale === "id") return id_report_reason(inputs)
	if (locale === "it") return it_report_reason(inputs)
	if (locale === "ru") return ru_report_reason(inputs)
	if (locale === "pt") return pt_report_reason(inputs)
	return ko_report_reason(inputs)
});